export default __webpack_public_path__ + "static/media/BANNER02.27e15466.png";